import { PopularProducts } from "../modules";

export const PopularProductsPage = () => {
  return <PopularProducts />;
};
